<template>
  <div class="flex flex-wrap">
    <div class="w-full sm:w-2/3 flex items-center break-all mb-2 sm:mb-0">
      <div class="w-8 flex items-center justify-center">
        <icon class="text-xl" icon="microphone"/>
      </div>
      <input ref="name"
             spellcheck="false"
             v-model="name"
             class="w-full px-1 border-1 bg-transparent"
             :class="editName ? 'text-input' : 'pointer-events-none'"
             @keypress.enter="rename"
             @blur="rename"
      />
    </div>
    <div class="flex-1 flex justify-start sm:justify-end" @click="$emit('open')">
      <div class="flex-none flex border-2 p-1 border-gray-500 rounded items-center">
        <icon class="text-xl mx-2 text-red-400 hover:text-red-500 cursor-pointer" icon="circle" v-show="!isRecording" @click="record"/>
        <icon class="text-xl mx-2 cursor-pointer opacity-50" v-show="isRecording" icon="stop" @click="stopRecording"/>
        <icon class="text-xl mx-2 text-green-500 cursor-pointer" v-show="hasAudio && !isPlaying" icon="play" @click="play"/>
        <icon class="text-xl mx-2 text-white cursor-pointer" v-show="hasAudio && isPlaying" icon="pause" @click="pause"/>
        <icon class="text-xl mx-2 opacity-50 cursor-pointer" v-show="hasAudio" icon="stop" @click="stopAudio"/>
        <span class="text-sm mx-2">{{minutes}}:{{seconds}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import recorder from '@/utils/recorder'
import database from '@/database'
import attributeMixins from '@/mixins/attribute'

export default {
  props: ['attribute', 'documentId'],
  mixins: [attributeMixins],
  data () {
    return {
      recorder: null,
      audio: null,
      audioElement: null,
      isRecording: false,
      interval: null,
      seconds: '00',
      minutes: '00',
      isPlaying: false,
      isPaused: false,
      hasAudio: false
    }
  },
  async mounted () {
    if (this.attribute.attachment === this.attribute._id) {
      this.hasAudio = true
    }
  },
  methods: {
    async record () {
      if (this.hasAudio) {
        this.stopAudio()
        this.stopCounter()
        this.hasAudio = false
      }
      this.isRecording = true
      this.isPlaying = false
      this.isPaused = false
      this.startCounter()
      this.recorder = await recorder()
      this.recorder.start()
    },
    async stopRecording () {
      this.isRecording = false
      this.isPlaying = false
      this.hasAudio = true
      this.stopCounter()
      const audioData = await this.recorder.stop()
      this.audioElement = audioData.element
      this.$emit('upload-attachment', this.attribute, audioData.audioBlob, 'audio/wav')
    },
    async play () {
      this.isPlaying = true
      if (this.audioElement === null) {
        this.$store.commit('startLoading')
        let attachment = await database.getAttachment(this.documentId, this.attribute.attachment)
        this.$store.commit('endLoading')
        this.audioElement = new Audio(URL.createObjectURL(attachment))
      }
      this.audioElement.play()
      if (this.isPaused) {
        this.isPaused = false
      } else {
        this.startCounter()
      }
      this.audioElement.addEventListener('ended', () => {
        this.stopCounter()
        this.isPlaying = false
      })
    },
    pause () {
      this.isPaused = true
      this.isPlaying = false
      this.audioElement.pause()
    },
    stopAudio () {
      this.isPlaying = false
      this.isPaused = false
      this.stopCounter()
      this.audioElement.pause()
      this.audioElement.currentTime = 0
    },
    startCounter () {
      this.clearCounter()
      let time = 0
      this.interval = setInterval(() => {
        if (this.isPaused) return
        time++
        this.minutes = this.pad(Math.floor(time / 60), 2)
        this.seconds = this.pad(time - (this.minutes * 60), 2)
      }, 1000)
    },
    stopCounter () {
      clearInterval(this.interval)
      this.clearCounter()
    },
    clearCounter () {
      this.seconds = '00'
      this.minutes = '00'
    },
    pad (n, width, z) {
      z = z || '0'
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    }
  }
}
</script>
